import checkout from "./form2";

const {
  formField2: {
    taxpayerName,
    taxId,
    taxAgencyId,
    taxAgencyName,
  },
} = checkout;

const initialValues2 = {
  [taxId.name]: "",
  [taxpayerName.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
};

export default initialValues2;
